<template>

    <div :style="pageStyle" id="listContainer" ref="chatContatiner" @scroll="showScorll" class="chatContatiner">

        <template v-if="arrayList && arrayList.length > 0">
            <div v-for="item, index in arrayList" :id="'QICON' + index" style="margin-bottom: 25px;" v-bind:key="index">

                <template v-if="item.msgType == 0">
                    <div style="display: flex;margin-bottom: 10px;">
                        <div class="QICON">
                            <template v-if="item.load == true">
                                <div class="QICONIcon" style="text-align: center;">
                                    <SyncOutlined style="font-size: 16px;color: white;" spin></SyncOutlined>
                                </div>



                            </template>
                            <template v-else>
                                <img src="../../../assets/ailogo.png" style="width: 100%;position: relative;" />
                            </template>
                        </div>
                        <!-- <div style="align-content: center;font-size: 16px;font-weight: bolder;    margin-left: 5px;">
                            Qiuu~
                        </div> -->
                    </div>
                    <div style="font-size: 16px;" v-if="!item.load == true">
                        <!-- <div v-if="articleType == '网络搜索' && item.msgType == 0 && getArrayType(item.data)"
                            style="text-align: justify;">
                            <div class="chat-bubble chat-bubble-left ai-chat">
                                <div v-for="(itemItem, index) in item.data" v-bind:key="index" style="margin-bottom: 20px;">
                                <div>
                                    <a :href="itemItem.link" target="_blank">
                                        <span style="font-weight: bolder;">{{ index + 1 }}、{{ itemItem.title }}</span>
                                    </a>
                                </div>
                                <div>
                                    {{ itemItem.content }}...
                                </div>

                            </div>
                            </div>
                          

                        </div> -->

                        <div style="font-size: 16px;width: 100%;">
                            <div class="chat-bubble chat-bubble-left ai-chat">

                                <div class="html" v-html="md.render(item.data) "></div>
                                <div v-if="!item.load == true&&item.paragraphs&&item.paragraphs.length>0">
                                    <div style="color: #756ddd;font-weight: bolder;">
                                        <div @click="toShowArray(index)">知识库引用
                                            <DownOutlined v-if="!item.showParagraphs" />
                                            <UpOutlined v-else />
                                        </div>

                                        <template v-if="item.showParagraphs">
                                            <div v-for="(itemItem,itemIndex) in item.paragraphs" v-bind:key="itemIndex">
                                                <!-- <div  class="html"  v-html="md.render(itemItem.content) "></div> -->
                                                <a @click="toShowContent(index,itemIndex)">{{itemIndex+1}}、{{itemItem.dataSetName
                                                    }}</a>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>


                        </div>


                    </div>
                </template>
                <template v-if="item.msgType == 1">

                    <div style="    text-align: right;
    display: flex;
    width: 100%;
    justify-content: flex-end;

">


                        <div style="font-size: 16px;width: 100%;">
                            <div class="chat-bubble chat-bubble-right">
                                <span style="white-space: pre-line">{{ item.data }}</span>
                            </div>


                        </div>

                    </div>

                </template>


            </div>
        </template>
    </div>


    <a-modal centered width="70%" :title="title" v-model:visible="contentModal" :closable="false"
        @ok="contentModal=false">
        <div v-html="md.render(content)" class="html">

        </div>
    </a-modal>

    <!-- <div @click="stopRequest">停止生成</div> -->

</template>
<script setup>
import { DownOutlined, UpOutlined } from '@ant-design/icons-vue';

import { fetchEventSource } from '@microsoft/fetch-event-source';


import { nextTick, onMounted, reactive, ref, watch, defineProps, defineEmits } from 'vue'
import { SyncOutlined } from "@ant-design/icons-vue"
import { toChatPage, recordChatPage } from '../qiuuindex';
import { toChatKimi } from '../gptTorch'

import store from '@/store';
import router from '@/router';
const showProp = defineProps(['postParams', 'sendText', 'active', 'conversationId', 'articleAppId', 'articleType', 'pageHeight', 'cardList'])
const showEmit = defineEmits(['toChangeSelectTrue', 'toChangeSendText', 'toChangeSendTextTrue', 'toReloadSession', "toShow"])
import MarkdownIt from 'markdown-it'
import { repeat } from 'lodash';

import { useSSEByXHR } from '@/untils/useSSE';

const md = new MarkdownIt({ html: true })
const conversationId = ref(null)
const pageStyle = ref()
const conversationAIId = ref(null)
const controller = new AbortController();
watch(() => showProp.active, (val, old) => {
    console.log(val.active != old.active, val, old, ' watchshowProp.active')

    if (val.articleAppId != '') {

        if (val.active != old.active) {
            arrayList.value = []
            pagination.total = 0
            pagination.current = 1

            nextTick(() => {
                if (val.active && val.active != 'newChat' && old.active == 0) {

                    reloaddata(true, true)
                }
            })
        }

    }

})
watch(() => router.currentRoute.value.query, (val, old) => {




    if (val && val.id && val.id != 'newChat') {
        arrayList.value = []
        pagination.total = 0
        pagination.current = 1

        reloaddata(true, true)
    }




})
const showContentButton = ref(false)
const emptyAvatar = ref('https://enplus.oss-cn-guangzhou.aliyuncs.com/file/4d57c99d-ca12-4aec-bdfd-645d2b45c86d.png')
const avatarSrc = ref(store.getters.avatar)
const pagination = reactive({
    current: 1,
    size: 10,
    total: 0,
    pages: 0,

})
const toShowArray = (index) => {

    arrayList.value[index].showParagraphs = !arrayList.value[index].showParagraphs
}
const chatContatiner = ref(null)
const reloaddataFlag = ref(false)
const previousScrollHeight = ref(0)
const handelWheel = (e) => {

    console.log('wheel', e, reloaddataFlag.value)
    if (showProp.articleType != '网络搜索' && reloaddataFlag.value == false && pageScrollButtom.value == true && pageScrollButtom.value == true && event.deltaY < 0 && chatContatiner.value.scrollTop === 0) {
        if (pageScrollButtom.value == true && pagination.pages > pagination.current) {

            reloaddataFlag.value = true
            pagination.current = pagination.current + 1

            reloaddata(true, false)





        }
        else {
            pageScrollButtom.value = true
        }
    }


}
const setShowScroll = ref(false)
const showScorll = (e) => {
    if (showProp.articleType != '网络搜索') {
        if (pageScrollButtom.value == true) {
            console.log(reloaddataFlag.value, 'showScorll')
            console.log(arrayList.value.length, pagination.pages, pagination.current, "showScorll", pagination.current + 1, chatContatiner.value.scrollTop)
            if (chatContatiner.value.scrollTop == 0 && arrayList.value.length > 0) {
                if (pagination.pages > pagination.current) {

                    reloaddataFlag.value = true
                    pagination.current = pagination.current + 1
                    const previousScrollHeight = chatContatiner.value.scrollHeight;
                    reloaddata(true, false)

                }
            }
        }
        else {
            pageScrollButtom.value = true
        }
    }


    console.log(pageScrollButtom.value, 'pageScrollButtom.valu')


}
const getArrayType = (value) => {
    if (value && Array.isArray(value)) return true
    return false
}
watch(() => showProp.pageHeight, (val) => {

    if (showProp.articleType != '网络搜索') {
        pageStyle.value = { 'height': showProp.pageHeight + 'px', 'overflow-y': pagination.pages > 1 ? 'scroll' : 'auto', 'padding': '20px 80px', }

    }

})
const paragraphs = ref([])
const title = ref("")
const content = ref("")
const contentModal = ref(false)
const toShowContent = (index, Index) => {
    title.value = arrayList.value[index].paragraphs[Index].dataSetName
    content.value = arrayList.value[index].paragraphs[Index].content
    console.log(content.value)
    contentModal.value = true
}
const { startSSE, stopSSE, isStreaming } = useSSEByXHR()

const toGetNoRepeatReference = (paragraphs) => {
    var noRepeatList = []
    if (paragraphs && paragraphs.length > 0) {

        paragraphs.forEach(element => {
            if (noRepeatList.findIndex(item => item.dataSetName == element.dataSetName) == -1) {
                var dataSetName = element.dataSetName
                const map = new Map();

                paragraphs
                    .filter(i => i.dataSetName === dataSetName)
                    .forEach(item => {
                        if (!map.has(item.page)) {
                            map.set(item.page, item); // 只保存第一次出现的
                        }
                    });


                var list = [...map.values()].sort((a, b) => a.page - b.page);
                var content = ""
                for (var listItem of list) {
                    content = content + listItem.content + "\n"
                }
                noRepeatList.push({
                    dataSetName: dataSetName,
                    content: content
                })
            }
        });
    }
    else noRepeatList = paragraphs
    return noRepeatList
}
const reloaddata = async (val, scrollFlag) => {

    showEmit('toChangeSelectTrue', true)
    // alert(showProp.active.active)
    // else if(showProp.articleType=='网络搜索'||showProp.active.active ||showProp.active.active==0 )

    if (val == true && showProp.active.active != 'newChat' && router.currentRoute.value.query.id && router.currentRoute.value.query.id != 'newChat') {

        console.log(showProp.cardList, 'showProp.cardList', router.currentRoute.value.query.id)
        recordChatPage({ id: router.currentRoute.value.query.id, current: pagination.current, size: 10 }).then((res) => {

            pagination.total = res.data.total
            pagination.pages = res.data.pages
            var result = res.data.records

            for (var i in result) {


                arrayList.value.push({
                    id: result[i].id, table: false, load: false, data: result[i].message, msgType: result[i].msgType,
                    paragraphs: result[i].jsonData ? toGetNoRepeatReference(result[i].jsonData.paragraphs) : [], showParagraphs: false
                })
            }
            if (arrayList.value.length > 0) {
                arrayList.value = [...new Set(arrayList.value)]
            }

            arrayList.value = arrayList.value.length > 0 ? arrayList.value.sort((a, b) => a.id - b.id) : arrayList.value
            // if(paragraphs.value&&paragraphs.value.length>0){
            //     console.log(paragraphs.value,'paragraphs.value')
            //     arrayList.value[1].paragraphs=paragraphs.value
            //     arrayList.value[1].showParagraphs=false
            // }

            // paragraphs.value=null
            console.log(arrayList.value, "arrayList.value")

            showEmit('toChangeSendText')
            showEmit('toChangeSelectTrue', false)

            //             if(reloaddataFlag.value==true)
            //             nextTick(()=>{
            //                 var   element = document.getElementById('QICON10');
            // var pelement = document.getElementById('listContainer');

            // pelement.scrollTop = element.offsetTop - 100
            //     // const currentScrollHeight = chatContatiner.value.scrollHeight;
            //     // chatContatiner.value.scrollTop = currentScrollHeight - previousScrollHeight.value;
            //     reloaddataFlag.value=false




            //             })

            if (scrollFlag != false)
                scrollButtom(false)

        })


    }
    else {
        var postData = showProp.postParams
        var result

        if (val == false) {
            result = {
                load: false,
                data: showProp.sendText.sendText,
                summary: null,
                type: postData,
                table: false,
                msgType: 1,
                id: arrayList.value.length > 0 ? arrayList.value[arrayList.value.length - 1].id + 1 : 1
            }
            postData = {

                "appId": showProp.articleType == '网络搜索' ? null : 123,
                clientId: store.getters.clientId,
                companyId: store.getters.company.companyId,
                "conversationId": showProp.conversationId,
                "question": showProp.sendText.sendText,
                "type": showProp.articleType == '网络搜索' ? 2 : 1,
            }
            arrayList.value.push(result)
            showEmit('toChangeSendText')

        }

        if (arrayList.value && arrayList.value.length > 0) {


            arrayList.value.push({ load: true, msgType: 0, id: arrayList.value[arrayList.value.length - 1].id + 1, data: "" })
            if (showProp.articleType != '网络搜索') {

                var articlePrompt = "根据用户输入的内容作为上下文，以专业、通俗易懂的方式来回答问题。\n" +
                    "回答要求：\n" +
                    "- 如果你不清楚答案，你需要澄清。\n" +
                    "- 避免提及你是从已知内容获取的知识。\n" +
                    "- 保持答案与已知内容中描述的一致。\n" +
                    "- 使用 Markdown 语法优化回答格式。\n" +
                    "- 使用与问题相同的语言回答。\n" +
                    "问题是：";

                var params = {
                    //会话id，一个会话中，服务端会自动包含上下文语义信息，如果没有id，那么服务端会生成一个新的
                    "conversationId": showProp.conversationId,
                    // 模型编码，TorchV bot平台对接的支持的模型编码，参考附录3.2
                    "model": "ep-20240925171523-r8bl2",
                    // 知识库Id，在平台的：知识库 功能列表可以查看，该参数可为空
                    "containerId": showProp.articleAppId == '1' ? ["1856595963846242304"] : ["1854423423040282624", "1856595963846242304"],
                    // 是否开启知识库rag检索，默认为true，如果不使用rag检索，则纯使用llm来进行回答
                    "ragSearch": true,
                    // 自定义Prompt模版，必须包含字符 ${context} 和 ${question}
                    "promptTemplate": "根据已知内容以专业、通俗易懂的方式来回答问题已知内容：${context}回答要求：-如果你不清楚答案，你需要澄清。-避免提及你是从已知内容获取的知识。-保持答案与已知内容中描述的一致。-使用Markdown语法优化回答格式。-使用与问题相同的语言回答。问题：${question}",
                    // 提问问题，和messages字段互斥，prompt字段不为空的情况下，优先使用该字段
                    // prompt字段不为空，并且multipleDialog=true，那么系统会在rag过程中自动开启检索&多轮会话，如果multipleDialog=false，那么不会进行多轮
                    "prompt": showProp.sendText.sendText,
                    // 消息历史，该字段和prompt互斥，两者不能同时为空，几种情况：
                    // 2.如果prompt为空，那么会使用messages字段，此时multipleDialog字段默认为true
                    // 3.messages的内容必须是数组，并且必须是user、assistant这样成对出现
                    // 4.如果prompt字段和messages字段都不为空，会以prompt进行查询使用

                    // 是否流式SSE请求,false的情况，响应内容为application/json
                    "stream": true,
                    // 是否开启多轮对话，默认true，如果开启该参数，必须保证conversationId一致，服务端会自动多轮会话，否则每次只试用prompt参数进行检索请求
                    "multipleDialog": true,
                    // 采样温度，控制输出的随机性，必须为正数取值范围是：(0.0,1.0]，不能等于 0，默认值为 0.95
                    "temperature": 0.95,
                    // 用温度取样的另一种方法，称为核取样取值范围是：(0.0, 1.0) 开区间，不能等于 0 或 1，默认值为 0.7模型考虑具有 top_p 概率质量tokens的结果
                    // 例如：0.1 意味着模型解码器只考虑从前 10% 的概率的候选集中取tokens
                    // 建议您根据应用场景调整 top_p 或 temperature 参数，但不要同时调整两个参数
                    "top_p": 0.7,
                    "encode": true
                }

                var token = ""

                if (params.containerId.length == 1) {
                    token = "Bearer " + "ak_756a17b3632b423db98257291a976a46121aba76eb4c5de851c18da9ccc426b4";
                }
                else {
                    token = "Bearer " + "ak_265a060d9c12b0e74885ef800a4e9ede24fb671aa99c9a751d7ba35f0e0dcacf";

                }


                // var result = {
                //         load: false,
                //         data: [],
                //         summary: null,
                //         type: postData,
                //         table: false,
                //         msgType: 0,
                //         id: arrayList.value[arrayList.value.length - 1].id + 1
                //     }
                //   arrayList.value.push(result)
                // ,{
                //   method:"POST",
                //   body:JSON.stringify(data),
                //   timeout: 0,
                //   dataType:"text/event-stream",
                //   headers:{
                //     "Content-Type":"application/json"
                //   }
                var dataStream = ""
                //       fetchEventSource('https://demo.torchv.com/openapi/api/v1/chat/completions', {
                //     method: 'POST',
                //     headers: {
                //       "Content-Type": 'application/json',
                //       "Authorization":token
                //     },
                //     body: JSON.stringify(params),
                //     onmessage(event) {
                //         showEmit('toChangeSendTextTrue', false)
                //         showEmit('toChangeSelectTrue', false)
                //       let data = JSON.parse(event.data);
                //       arrayList.value[arrayList.value.length-1].load=false
                //      arrayList.value[arrayList.value.length-1].data=arrayList.value[arrayList.value.length-1].data+data.choices[0].message.content


                //         console.log(data.choices[0],'data.choices[0]')
                //         scrollButtom(true)

                //     },
                //     onerror(error) {
                //         arrayList.value[arrayList.value.length-1].data="网络异常"
                //         scrollButtom(true)
                //       console.error('Stream encountered error:', error);
                //       throw error;
                //     },
                //     onclose(){
                //         arrayList.value[arrayList.value.length-1].load=false

                //     }
                //   });

                //   fetchEventSource('https://demo.torchv.com/openapi/api/v1/chat/completions', {
                // method: 'POST',
                // headers: {
                //   "Content-Type": 'application/json',
                //   "Authorization":token
                // },
                // body: JSON.stringify(params),
                // onmessage(event) {
                //   if (event.data === '[DONE]') {
                //     console.log('Stream ended');
                //     return;
                //   }
                //   let data = JSON.parse(event.data);
                //   dataStream.value += data.data;
                //   // 更新UI等操作
                // },
                // onerror(error) {
                //   console.error('Stream encountered error:', error);
                // }

                //   let response =  await  fetch("http://120.78.145.43:9092/chat/streamDemo?question=ce",{

                //     dataType:"text/event-stream",
                //     headers:{
                //       "Content-Type":"application/json",
                //    }
                //   });
                //   console.log(response);
                //   console.log( response.body)
                //   // if (!response.ok) {
                //   //   throw new Error('Network response was not ok');
                //   // }

                //   const reader = response.body.getReader();
                //   const textDecoder = new TextDecoder();
                //   let result = true;
                //   let output = ''

                //   while (result) {
                //     const { done, value } =  await  reader.read();

                //     if (done) {
                //       console.log('Stream ended');

                //       result = false;
                //       break;
                //     }
                //     else{
                //         // console.log(new TextDecoder().decode(value).)

                //         console.log(new TextDecoder().decode(value).trim().replaceAll(/\n/g,''))
                //     }



                //   }
                // const abortController = new AbortController();  // 创建一个新的 AbortController 实例
                //   const timeoutId = setTimeout(() => {
                //     console.log('Request timed out');
                //     showEmit('toChangeSendTextTrue', false)
                //         showEmit('toChangeSelectTrue', false)
                //         arrayList.value[arrayList.value.length-1].load=false
                //         arrayList.value[arrayList.value.length-1].data="网络异常，请重新提问"
                //         scrollButtom(true)
                //     abortController.abort();  // 超时后中止请求
                //   }, 60000);  // 设置超时时间，默认是 5000 毫秒（5秒）


                console.log(store.getters.appList, router.currentRoute.value.query.knowId, 'xixi')
                var dataStream = ""
                try {
          
    //                     startSSE('http://120.78.145.43:9091/chat/streamingChat',{
    //                           "appId": store.getters.appList.find(item => item.id == Number(router.currentRoute.value.query.knowId)).appId,
    //                         clientId: store.getters.clientId,
    //                         companyId: store.getters.company.companyId,
    //                         "conversationId": router.currentRoute.value.query.conversationId ? router.currentRoute.value.query.conversationId : null,
    //                         "question": showProp.sendText.sendText,
    //                         "type": showProp.articleType == '网络搜索' ? 2 : 1,
    //                 },{
    //                       onMessage(event) {
    //                       console.log('event',event)
    //    showEmit('toChangeSendTextTrue', false)
    //                         showEmit('toChangeSelectTrue', false)
    //                         //data:{}
    //                         if (event&&event.indexOf('data:') == 0) {

    //                             let data = JSON.parse(event.substring(5, event.length));
    //                             if (data.choices && data.choices.length > 0 && data.choices[0].message) {
    //                                 console.log(data.choices, 'hahahaha')
    //                                 arrayList.value[arrayList.value.length - 1].load = false
    //                                 arrayList.value[arrayList.value.length - 1].data = arrayList.value[arrayList.value.length - 1].data + data.choices[0].message.content
    //                                 conversationId.value = data.conversationId
    //                                 console.log(data.paragraphs, 'paragraphs')
    //                                 arrayList.value[arrayList.value.length - 1].paragraphs = toGetNoRepeatReference(data.paragraphs)

    //                                 paragraphs.value = arrayList.value[arrayList.value.length - 1].paragraphs
    //                                 arrayList.value[arrayList.value.length - 1].showParagraphs = false
    //                                 console.log(data.choices[0], 'data.choices[0]')
    //                                 scrollButtom(true)
    //                             }

    //                         }


    //   },
    //   onComplete() {
    //      console.log('onclose:', 'onclose');
    //                         arrayList.value[arrayList.value.length - 1].load = false
    //                         pagination.total = arrayList.value.length
    //                         if ((showProp.conversationId == null)) {

    //                             showEmit('toReloadSession', conversationId.value)
    //                             conversationId.value = null

    //                         }
    //                         else {
                            
    //                           if(arrayList.value[arrayList.value.length - 1].data==''){
    //                                 showEmit('toChangeSendTextTrue', false)
    //                                 showEmit('toChangeSelectTrue', false)
    //                                 arrayList.value[arrayList.value.length - 1].data = "网络异常，请重新提问"
    //                                 scrollButtom(true)
    //                             }
                               
    //                             paragraphs.value = null
    //                         }

    //   },
    //    onError(err) {
    //     showEmit('toChangeSendTextTrue', false)
    //                         showEmit('toChangeSelectTrue', false)
    //                         arrayList.value[arrayList.value.length - 1].load = false
    //                         arrayList.value[arrayList.value.length - 1].data = "网络异常，请重新提问"
    //                         scrollButtom(true)
    //                         console.log('Stream encountered error:', error);
    //                         //   clearTimeout(timeoutId);
    //                         throw error;

    //   },


    //                 })
                    fetchEventSource('http://120.78.145.43:9091/chat/streamingChat', {
                        method: 'POST',
                        signal: controller.signal,
                        headers: {
                            "Content-Type": 'application/json',
                        },
                        openWhenHidden: true,
                        body: JSON.stringify({
                            "appId": store.getters.appList.find(item => item.id == Number(router.currentRoute.value.query.knowId)).appId,
                            clientId: store.getters.clientId,
                            companyId: store.getters.company.companyId,
                            "conversationId": router.currentRoute.value.query.conversationId ? router.currentRoute.value.query.conversationId : null,
                            "question": showProp.sendText.sendText,
                            "type": showProp.articleType == '网络搜索' ? 2 : 1,
                        }),
                        onmessage(event) {

                            showEmit('toChangeSendTextTrue', false)
                            showEmit('toChangeSelectTrue', false)

                            if (event.data.indexOf('data:') == 0) {

                                let data = JSON.parse(event.data.substring(5, event.data.length));
                                if (data.choices && data.choices.length > 0 && data.choices[0].message) {
                                    console.log(data.choices, 'hahahaha')
                                    arrayList.value[arrayList.value.length - 1].load = false
                                    arrayList.value[arrayList.value.length - 1].data = arrayList.value[arrayList.value.length - 1].data + data.choices[0].message.content
                                    conversationId.value = data.conversationId
                                    console.log(data.paragraphs, 'paragraphs')
                                    arrayList.value[arrayList.value.length - 1].paragraphs = toGetNoRepeatReference(data.paragraphs)

                                    paragraphs.value = arrayList.value[arrayList.value.length - 1].paragraphs
                                    arrayList.value[arrayList.value.length - 1].showParagraphs = false
                                    console.log(data.choices[0], 'data.choices[0]')
                                    scrollButtom(true)
                                }

                            }
                            // clearTimeout(timeoutId);

                        },
                        onerror(error) {
                            showEmit('toChangeSendTextTrue', false)
                            showEmit('toChangeSelectTrue', false)
                            arrayList.value[arrayList.value.length - 1].load = false
                            arrayList.value[arrayList.value.length - 1].data = "网络异常，请重新提问"
                            scrollButtom(true)
                            console.log('Stream encountered error:', error);
                            //   clearTimeout(timeoutId);
                            throw error;
                        },
                        onclose() {
                            console.log('onclose:', 'onclose');
                            arrayList.value[arrayList.value.length - 1].load = false
                            pagination.total = arrayList.value.length
                            if ((showProp.conversationId == null)) {

                                showEmit('toReloadSession', conversationId.value)
                                conversationId.value = null

                            }
                            else {
                            
                              if(arrayList.value[arrayList.value.length - 1].data==''){
                                    showEmit('toChangeSendTextTrue', false)
                                    showEmit('toChangeSelectTrue', false)
                                    arrayList.value[arrayList.value.length - 1].data = "网络异常，请重新提问"
                                    scrollButtom(true)
                                }
                               
                                paragraphs.value = null
                            }
                            
                            //   clearTimeout(timeoutId);
                        },



                    })
                } catch (error) {
                    console.log('catcherror',error)
                    showEmit('toChangeSendTextTrue', false)
                    showEmit('toChangeSelectTrue', false)
                    arrayList.value[arrayList.value.length - 1].load = false
                    arrayList.value[arrayList.value.length - 1].data = "网络异常，请重新提问"
                    scrollButtom(true)
                    // clearTimeout(timeoutId);
                }

            }
            else {
                //                 fetch('http://112.74.85.40:8050/moonshot/websearch',{
                //     method:'POST',
                //     body:JSON.stringify({content:showProp.sendText.sendText})
                // })	
                toChatPage({
                    "appId": null,
                    clientId: store.getters.clientId,
                    companyId: store.getters.company.companyId,
                    "conversationId": conversationAIId.value,
                    "question": showProp.sendText.sendText,
                    "type": 2
                })
                    .then((res) => {
                        showEmit('toChangeSendTextTrue', false)
                        showEmit('toChangeSelectTrue', false)
                        arrayList.value[arrayList.value.length - 1].load = false
                        arrayList.value[arrayList.value.length - 1].data = res.data.msg[1].message

                        conversationAIId.value = res.data.conversationId

                        scrollButtom(true)

                    }).catch(() => {
                        showEmit('toChangeSendTextTrue', false)
                        showEmit('toChangeSelectTrue', false)
                        arrayList.value[arrayList.value.length - 1].load = false
                        arrayList.value[arrayList.value.length - 1].data = "网络异常，请重新提问"



                        scrollButtom(true)

                    })

                    //       fetch('http://112.74.85.40:8050/moonshot/websearch', {
                    //         method: 'POST', // 指定请求方法
                    //     headers: {
                    //         'Content-Type': 'application/json'
                    //     },
                    //     body: JSON.stringify({content:showProp.sendText.sendText})

                    //   }).then((res)=>{
                    //     console.log(res)
                    //   })


                    ;



            }
            //  else{
            //     toChatPage(postData).then((res) => {
            //     setChat(res, postData);
            //     console.log('xixitoChatPage')


            // }).catch((error) => {

            //     console.log(error, 'xixicatch')
            // })
            //  }
        }


    }

    nextTick(() => {
        showEmit('toShow')
        var element = document.getElementById('listContainer');
        console.log(element)
        if (element) {
            //element.scrollIntoView({ behavior: 'smooth', block: 'end' });
            element.scrollTop = element.scrollHeight;
        }


        if (showProp.articleType == '网络搜索') {

            nextTick(() => {
                var parentELement = document.querySelector('.QP')

                if (parentELement) {

                    var childrenElement = document.querySelector('.QP-Header')

                    if (childrenElement) {
                        console.log(parentELement.offsetHeight + "" + childrenElement.offsetHeight + "childrenElement.offsetHeight")
                        var pageHeight = parentELement.offsetHeight - childrenElement.offsetHeight - 40 - 42 - 10 - 20

                        console.log(pageHeight, 'pageHeight')
                        pageStyle.value = { 'height': pageHeight + 'px', 'overflow-y': 'auto', 'padding': '20px 280px' }

                    }
                }
            })
        }
        else {

            pageStyle.value = { 'height': showProp.pageHeight + 'px', 'overflow-y': pagination.pages > 1 ? 'scroll' : 'auto', 'padding': '20px 80px', }

        }






    })
}

const stopRequest = () => {
    controller.abort();
};
const setChat = (res, postData) => {
    console.log(res, "xixi1")
    var flag = false
    res = { data: res.data }
    var result = {
        load: false,
        data: [],
        summary: null,
        type: postData,
        table: false,
        msgType: 0,
        id: arrayList.value[arrayList.value.length - 1].id + 1
    }


    if (res == null)
        result.data = "网络异常，请重新提问"
    else if (showProp.articleType == '网络搜索') {


        result.data = JSON.parse(res.data.msg[1].message).length == 0 ? '网络异常，请重新提问' : JSON.parse(res.data.msg[1].message)
        flag = true

    }
    else {
        console.log(res, 'choices')
        result.data = res.data.choices[0].message.content
        // result.data = res.data.msg[1].message
        flag = true
    }



    arrayList.value[arrayList.value.length - 1] = (result)
    console.log(arrayList.value, 'result')

    showEmit('toChangeSendTextTrue', false)
    showEmit('toChangeSelectTrue', false)
    pagination.total = arrayList.value.length

    scrollButtom(flag)
    //  更新
    //postData.conversationId == null
    if (showProp.articleType != '网络搜索' && (postData.conversationId == null) && res != null) {
        reloadFresh.value = true
        showEmit('toReloadSession', res)

    }



}



const pageScrollButtom = ref(true)
const scrollButtom = (flag) => {

    nextTick(() => {

        if (pagination.current == 1) pageScrollButtom.value = false
        var element

        if (flag == true || flag == false) {

            // if(showProp.articleType!='网络搜索'){
            element = document.getElementById('listContainer');

            // console.log(element, 'element.scrollHeight', element.scrollHeight)
            if (element) {
                //element.scrollIntoView({ behavior: 'smooth', block: 'end' });
                element.scrollTop = element.scrollHeight;
                console.log(element.scrollHeight, 'element.scrollHeight')
            }
            // }
            // else if (arrayList.value.length > 2) {
            //     element = document.getElementById('QICON' + (arrayList.value.length - 1).toString());
            //     var pelement = document.getElementById('listContainer');
            //     console.log(element, 'QICON' + pelement.clientHeight, pelement.scrollTop, element.offsetTop - 100)
            //     pelement.scrollTop = element.offsetTop - 100
            // }


        }
        else {
            element = document.getElementById('listContainer');
            // console.log(element, 'element.scrollHeight', element.scrollHeight)
            if (element) {
                //element.scrollIntoView({ behavior: 'smooth', block: 'end' });
                element.scrollTop = element.scrollHeight;
            }
        }



    })
}
const isArray = (val) => {
    return val instanceof Array
}







const arrayList = ref([

])
watch(() => router.currentRoute.value.query, (val, old) => {
    console.log(val, old, 'arrayList')
    arrayList.value = []

})
watch(() => showProp.postParams, (val) => {

    if (val != null) {
        reloaddata()
    }
})

watch(() => showProp.sendText, (val) => {
    console.log(val, 'showProp.sendText')
    if (val != null && val.send == true) {
        reloaddata(false)
    }
})

onMounted(() => {





})
</script>
<style lang="less">
.html {
    padding: 0px 5px;
    padding-left: 10px;

    //    li::marker {
    //   color: red;
    //   font-size: 1.5em;
    //   margin-left:10px;


    // }
    p {
        margin-bottom: 0px;
        white-space: pre-line;
    }

    img {
        width: -webkit-fill-available;
    }

}

.markdown {
    td {
        padding-right: 20px;
    }
}

.chatTable {
    thead tr th:nth-of-type(1) {
        padding: 1px;
    }

}

ul {
    list-style-type: none;
}
</style>
<style scoped>
.chatContatiner {
    padding: 0px 20px;
    ;
}

.chat-bubble {
    width: 100%;
    color: #333;
    border-radius: 5px;
    box-shadow: 3px 5px 15px rgba(0, 0, 0, .2);
    padding: 5px 10px;
    width: auto;
    max-width: 100%;
    text-align: left;
    display: inline-block !important;
    position: relative;
    word-break: break-all;
    background-color: #ffffff;
    transition: all .2s;
    cursor: pointer;
}

.chat-bubble:hover {
    transform: scale(1.03);
}

.chat-bubble-left {}

.chat-bubble-left.ai-chat {
    border: 1px solid;
    border-image: linear-gradient(90deg, #725bdf 0%, #80a3d5 70%, #bdceea 100%) 1 1 1 1;

}


.chat-bubble-left::before {
    content: '';
    width: 10px;
    height: 10px;
    left: -10px;
    top: calc(50% - 5px);
    position: absolute;
    border-left: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-top: 5px solid transparent;
    border-right: 5px solid #7d93d7;
}

.chat-bubble-right {
    background-color: #e0dfff;
}

.chat-bubble-right:after {
    content: '';
    width: 10px;
    height: 10px;
    right: -10px;
    top: calc(50% - 5px);
    position: absolute;
    border-left: 5px solid #e0dfff;
    border-bottom: 5px solid transparent;
    border-top: 5px solid transparent;
    border-right: 5px solid transparent;
}

.chatContainer {
    padding: 10px;
}

.QICONIcon {
    display: flex;
    width: 100%;
    height: 100%;
    background: #725bdf;
    align-items: center;
    justify-content: center;
}

.QICON {
    margin-bottom: 10px;
    width: 30px;
    height: 30px;

    display: flex;
    justify-content: center;
    align-items: center;


}
</style>